import type { CustomerTemplate, LibraryTemplate } from '@/api/types/template'
import type { TemplateListItem } from '@/lib/templates/types/template-list-item'

export function normalizeCustomerTemplate(template: CustomerTemplate): TemplateListItem {
  return {
    id: template.customerTemplateId,
    templateName: template.templateName,
    urlSmallPreview: template.urlSmallPreview ?? '',
    urlLargePreview: template.urlLargePreview ?? '',
    keywordIds: [],
    raw: template,
  }
}

export function normalizeLibraryTemplate(template: LibraryTemplate): TemplateListItem {
  return {
    id: template.templateId,
    templateName: template.templateName,
    urlSmallPreview: template.urlSmallPreview,
    urlLargePreview: template.urlLargePreview,
    keywordIds: (template.cmsKeywordInfo ?? []).map((keyword) => String(keyword.cmsKeywordId)),
    raw: template,
  }
}
